(function () {
    'use strict';

    angular.module('processModule')
        .controller('favoritesTreeView', favoritesTreeViewController);

    favoritesTreeViewController.$inject = ['$scope', '$timeout', '$http', '$state', 'pubSub', 'configService'];

    function favoritesTreeViewController($scope, $timeout, $http, $state, pubSub, configService) {
        var vm = this;
        var killUpdateFavoritesProcesses = null;

        vm.isExpanded = false;
        vm.initialize = initialize;
        vm.items = [];
        vm.selectNodeInAreaTree = selectNodeInAreaTree;
        vm.handleExpandArea = handleExpandArea;
        $scope.favoritesList = [];
        vm.wrapText = configService.getBool(HandbookConfiguration.WrapTextInNavigationTree);

        function initialize() {
            killUpdateFavoritesProcesses = pubSub.subscribe(broadcastType.updateFavoritesProcesses, updateFavoritesProcesses);
        }

        $scope.$on('$destroy', function () {
            killUpdateFavoritesProcesses();
        });

        $scope.$on("Favorites_GetProcessFavoritesList", function () {
            getFavoritesList();
        });
        
        function getFavoritesList() {
            $http.get(handbookRequests.GetFavoritesProcessesAreasRequest)
                .success(function (data, status, headers, config) {
                    if (data) {
                        decorateNodes(data.areas, data.processes);
                        $scope.favoritesList = data.processes;
                        $scope.favoritesList = $scope.favoritesList.concat(data.areas);
                    }
                });
        }

        $scope.options = {
            dropped: function (event) { },
            beforeDrop: function (event) { }
        };

        function updateFavoritesProcesses(target) {
            if (target) {
                getFavoritesList();
            }
        }

        function handleExpandArea(expanded, itemId, selectedNode) {
            if (expanded == true && selectedNode.$modelValue.type == 0 && (selectedNode.$modelValue.childCount > 0)) {
                var siblings = selectedNode.$parentNodeScope == null ? selectedNode.favoritesList : selectedNode.$parentNodeScope.$modelValue.items;
                var modelValue = selectedNode.$modelValue;
                if (modelValue.isLoaded) {
                    return;
                } else {
                    modelValue.isLoaded = true;
                }

                $http.get(handbookRequests.GetProcessAreasRequest, {
                    params: {
                        areaId: itemId,
                        showProcessesInTree: true,
                        isOnlyApproved: true
                    }
                })
                    .success(function (data, status, headers, config) {
                        if (data) {
                            decorateNodes(data.areas, data.processes);
                            var length = siblings.length;
                            for (var i = 0; i < length; i++) {
                                if (siblings[i].id == itemId) {
                                    vm.selectedNode = siblings[i];
                                    if (siblings[i].items == null) {
                                        siblings[i].items = [];
                                    }
                                    siblings[i].items = siblings[i].items.concat(data.areas);
                                    siblings[i].items = siblings[i].items.concat(data.processes);
                                    break;
                                }
                            }
                        }
                    },
                        function (data, status, headers, config) {
                            //modelValue.items = [];
                        });
            }
        }

        function selectNodeInAreaTree(node, item, collapsed, $event) {
            if (item.type == 0 || !item.type) {
                $state.go('process-area-detail', { areaId: item.id });
            }
            else if (item.type == 1) {
                $state.go('process-detail', { processNumber: item.processNumber });
            }
            let isSelectedFolder = $(event.target).hasClass('selected');
            if ((isSelectedFolder || collapsed) && HandbookConfiguration.ToggleFolderUponClick.toUpperCase() == "TRUE") {
                vm.isExpanded = true;
                item.expanded = !item.expanded;
                handleExpandArea(collapsed, item.id, node);
                $scope.toggle(node);
            }
            setHighlight($event);
        }

        $scope.toggle = function (scope) {
            scope.toggle();
        };

        function decorateNodes(areas, processes) {
            if (areas && areas.length) {
                for (var i = 0; i < areas.length; i++) {
                    areas[i].type = 0;
                }
            }
            if (processes && processes.length) {
                for (var i = 0; i < processes.length; i++) {
                    processes[i].type = 1;
                    processes[i].id = processes[i].processNumber;
                }
            }
        }

        function setHighlight(event) {
            $('.selected').removeClass('selected');
            $(event.target).addClass('selected');
        }

    };

})();

